import { alertController, AlertOptions } from '@ionic/core';
import { translate } from './translate';

export async function showAlert(header: string, message?: string): Promise<void> {
  return new Promise(async (resolve) => {
    const options: AlertOptions = {
      header,
      message,
      buttons: [{
        text: translate('OK'),
        handler: () => {
          resolve(); 
        }
      }]
    };

    const alert = await alertController.create(options);
    alert.onDidDismiss().then(() => resolve());
    await alert.present();
  });
}